import { render, staticRenderFns } from "./booking-form.vue?vue&type=template&id=6e6edbe6&scoped=true"
import script from "./booking-form.vue?vue&type=script&lang=js"
export * from "./booking-form.vue?vue&type=script&lang=js"
import style0 from "./booking-form.vue?vue&type=style&index=0&id=6e6edbe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6edbe6",
  null
  
)

export default component.exports